export enum GeneralConfigAttribute {
  NumberOfDaysForNewlyRentedObjects = 'number_of_days_for_newly_rented_objects',
  ObjectRowTypes = 'object_row_types'
}
